export const initialState = {
	userDetail: {}
};
